import * as React from "react";

const SvgExtendedInfoIcon = (props) => (
  <svg
    width={15}
    height={15}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx={7.5} cy={7.5} r={7} stroke="#242424" />
    <path
      d="M7.007 11.727V5.895h.984v5.832h-.984Zm.504-7.032a.718.718 0 0 1-.492-.18.598.598 0 0 1-.192-.456c0-.192.064-.344.192-.456.136-.12.3-.18.492-.18s.352.06.48.18a.56.56 0 0 1 .204.456.582.582 0 0 1-.204.456.675.675 0 0 1-.48.18Z"
      fill="#242424"
    />
  </svg>
);

export default SvgExtendedInfoIcon;
